export const routes = {
  en: {
    home: "/en",
    profile: "/en/my-profile",
    itineraries: "/en/itineraries",
    nearbyPlaces: "/en/nearbyplaces/:Id",
    editItinerary: "/en/edit_itinerary/:id",
    itinerary: "/en/itinerary/:id",
    itinerarySlug: "/en/trips/:slug",
    login: "/en/login",
    signup: "/en/signup",
    forgetPassword: "/en/forgetpassword",
    resetPassword: "/en/resetpassword",
    confirmEmail: "/en/confirm-email",
    inbox: "/en/messages",
    messages: "/en/messages/:username",
    myTrips: "/en/my-trips",
    CreatedTrips: "/en/created-trips",
    InvitedTrips: "/en/invited-trips",
    FromTheCommunity: "/en/from-the-community",
    cityTrips: "/en/trips/in/:city",
    SavedTrips: "/en/saved-trips",
    properties: "/en/lodgings",
    worldMap: "/en/world-map",
    privacyPolicy: "/en/privacy-policy",
    community: "/en/community"
  },
  es: {
    home: "/es",
    editItinerary: "/es/edit_itinerary/:id",
    itinerary: "/es/itinerary/:id",
    itinerarySlug: "/es/viajes/:slug",
    profile: "/es/my-profile",
    itineraries: "/es/itinerarios",
    nearbyPlaces: "/es/lugares-cercanos/:Id",
    login: "/es/iniciar-sesion",
    signup: "/es/registro",
    forgetPassword: "/es/recuperar-contrasena",
    resetPassword: "/es/restablecer-contrasena",
    confirmEmail: "/es/confirmar-email",
    inbox: "/es/mensajes",
    messages: "/es/mensajes/:username",
    myTrips: "/es/mis-viajes",
    CreatedTrips: "/es/viajes-creados",
    InvitedTrips: "/es/viajes-invitado",
    SavedTrips: "/es/viajes-guardados",
    FromTheCommunity: "/es/de-la-comunidad",
    cityTrips: "/es/viajes-en/:city",
    properties: "/es/alojamientos",
    worldMap: "/es/mapa-mundial",
    privacyPolicy: "/es/politica-de-privacidad",
    community: "/es/community"

  }
};
